export default {
    //首页
    home: {
        nav: {
            Home: '首页',
            Technologies: '技术',
            Products: "产品",
            AboutUs: "关于我们",
            Newsroom: "新闻中心"
        },
        childrenNav: {
            FaceRecognition: "人脸识别",
            ProductequiPment: "后装主动安全硬件产品",
            PreinstalledSolution: "前装主动安全硬件产品",
            sdk:"主动安全SDK",
            CloudPlatform: "车辆管理云平台",
            About: "公司简介",
            Joinus: "加入我们"
        },
        grandchildrenNav:{
            KYLFD:"KY-LFD商用车主动安全设备",
            Polaris:"KY-BJX 北极星智能行驶记录仪",
            KYJLY:"KY-JLY主动安全智能记录仪",
            KYHSj:"KY-HSJ主动安全智能后视镜",
            HDDashcam:"高清行车记录仪",
            Intelligent:"智能车载核心板",
            installedADAS:"前装ADAS产品",
            installedDMS:"前装DMS产品",
            Genera:"标准版ADAS SDK",
            Dashcam:"行车记录仪专用ADAS SDK",
            Professional:"升级版SDK",
            YKYVehicles:"易开云车辆管理平台"
        },
        hometop: "智能驾驶解决方案提供者",
        homecenter: "观看视频 了解我们",
        homebottom: "合作伙伴 · Partners"
    },
    //页面下方地址以及联系方式
    address: {
        tel: "公司联系电话: 010-53686837",
        Business: "商务合作（邮箱）：bd@adasplus.com",
        JoinUs: "招聘：https://www.lagou.com/gongsi/j141699.html",
        Beijing: "北京总部：北京市朝阳区紫月路18号院11号楼（东侧）4层",
        Shenzhen: "深圳分部：深圳市南山区南海大道3025号创意大厦2楼",
        // Shenzhen: "深圳分部：深圳市南山区南头街道创意大厦2楼",
        // Taiwan: "台湾分部：台湾台中市南区学府路135巷2弄10号",
        Taiwan: "台湾分部： 台中市南区仁和路292号4楼之5",
       
        Changsha: "长沙分部：长沙市开福区北辰三角洲凤凰天街苑B1E1区1栋18025号",
        enterpriseName:"开易（北京）科技有限公司"
    },
    //技术页
    Technologies: {
        TechnologiesTop: "用技术驱动驾驶新体验",
        TechnologiesAdas: "基于内置于车辆前方挡风玻璃上的数字摄像头，系统可以监测并测量本车到其他车辆,行人以及车道的距离在危险紧急情况下提供给驾驶员及时的警告",
        Technologiesvideo: "ADAS演示视频",
        ADAStext: {
            LDW: "车道线偏移报警",
            FCW: "前车碰撞预警",
            PCW: "行人碰撞预警",
            HW: "跟车距离预警",
            SG: "前车启动提醒",
            TSR: "交通限速标志提醒"
        },
        DMS: {
            DMStext: "疲劳预警系统可以根据驾驶人员表情、姿态、动作等，快速、实时、有效地检测驾驶状态。当驾驶员出现以下不利于专心驾驶的行为时，设备会向驾驶员发出预警信号。",
            Distraction: "左顾右盼",
            Calling: "打电话",
            Tired: "疲劳",
            Smoking: "吸烟",
        },
        Face: {
            FaceRecognition: "人脸识别 · Face Recognition",
            Takingpictures: "1、设备拍照",
            Uploadingpictures: "2、传送后台",
            FaceVerification: "3、后台对比",
            Informationfeedback: "4、反馈结果",
            ClickHere: "人脸比对测试链接",
            HeadCounting: "人数清点",
            HeadCountingtext: "设备可以辨认出车中人数，并在检测到人脸后拍照，记录车上的司机和乘客，传到管理后台保存，需要时可查看调阅。",
            IntrusionWarning: "入侵报警",
            IntrusionWarningtext: "用户可以设置黑名单或白名单，黑名单内或白名单外的人出现在摄像头中时，设备会发生报警。"
        }
    },
    //产品页
    Products: {
        ProductsTop: "软硬件自主研发",
        commercial: {
            Active: "商用车主动安全设备",
            ActiveKYLFD: "KY-LFD高级辅助驾驶设备",
            ActiveKYLFDtext: "/T 1094-20162017年初国家颁布的JT《运营客车技术安全条件》中要求大于9米的客车应符合JT/T833规定配备前视系统。开易的二代前视系统已经顺利通过JT/T833法规。",
            ActiveKYLFDbottom: "后装设备主机",
            function: "功能介绍:",
            commercialAdas: "1 ADAS预警：在危险发生前及时的做前方碰撞预警、车道偏移预警，降低潜在风险；",
            commercialtired: "2 疲劳驾驶防范：在驾驶员发生分心、疲劳等具有安全隐患的行为时，向驾驶员发出预警信号。",
            camera: "后装设备副机（摄像头）"
        },
        front: {
            fronttitle: "前装方案",
            frontadas: "ADAS智能辅助驾驶系统KY101",
            Features: "功能介绍",
            Featurestext: " 实时识别前方车辆、行人和车道线，检测本车与前车或行人之间的距离、方位及相对速度等数据，以及本车在车道中的位置，并由此做出预警判定。",
            Featuresbottom: "前装设备",
        },
        SDK: {
            sdkpone: "目前开易与众多知名商家合作，为其智能后视镜、车机提供集成了ADAS功能的SDK软件包。",
            sdkptwo: "开易科技的SDK提供了前车碰撞预警、车道偏离预警、前车起步提示，行人避让提示、疲劳预警等功能，准确率高，漏报率低，",
            sdkpthree: "有效降低CPU和内存占用率。",
            sdkpfour: "目前，我们已达到数百万的用户规模",
            Factory: "前装ADAS",
            Dash: "后装行驶记录仪+ADAS",
            Intelligent: "智能后视镜+ADAS",
            Navigation: "ADAS+导航"
        },
        service: {
            servicetitle: "服务平台",
            servicetext: "结合商用车主动安全设备，开易科技的车辆系统预警平台可以帮助商家用户更多维度，更有针对性，更加高效快捷的管理车辆和驾驶员。同时增加了对驾驶员和车辆的安全保障，通过记录每一次具有潜在危险的不良驾驶行为，防患于未然。车辆系统预警平台现在正在开发更多的功能，以期提供给用户更好的工具和体验。"
        }
    },
    //关于我们
    about: {
        abouttitle: "任重道远 不畏前行",
        company: "公司简介 · About Us",
        companytext: "开易（北京）科技有限公司成立于2016年初，最初由海归博士以及国内资深专家为主要成员组成的创始团队，现在已经形成一套以算法，产品，硬件，设计，运营在内的完整体系。开易科技致力于通过图像识别、机器学习和人工智能技术，为汽车提供高精确度的辅助驾驶安全算法。我们着眼于前装视觉ADAS算法为基础，与雷达融合为客户提供解决方案，同时还为后装市场设计了算法模型，为车载智能硬件提供ADAS SDK。",
        companybottom: "我们的愿景是用技术驱动驾驶新体验。",
        Joinus: "加入我们 · Join Us",
        Joinustext: "开易目前正在高速发展，希望更多的志同道合、心怀理想的人才加入我们，与我们一起，在智能驾驶领域砥砺前行。在这里付出就有回报！",
        Joinuslook: "查看职位",
    },
    //新闻
    Journalism: {
        Journalismtitle: "循序渐进 务实创新",
        new: "新闻动态 · News",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/Chinese.js